<ion-header class="ion-no-border ion-header-modal-desktop">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        data-cy="close-order-product-options-modal-button"
        (click)="dismissModal(true)"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label data-cy="select-order-number-label">
      {{ 'i18n.requestCredit.selectOrderNumber' | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  *ngIf="
    (serviceRequestService?.orders$ | async)?.ordersLoaded as loaded;
    else spinner
  "
  class="ion-content-modal-desktop"
>
  <ng-container
    *ngIf="(serviceRequestService?.orders$ | async)?.myOrders as orders"
  >
    <div *ngIf="!orders?.length && loaded" class="no-data-found">
      <p data-cy="no-order-numbers-found-text">
        {{ 'i18n.requestCredit.noOrderNumbersFound' | translate }}
      </p>
    </div>

    <ion-grid *ngIf="orders?.length">
      <ion-row>
        <!-- Order Number Options -->
        <ion-col size="5.75">
          <ion-list class="orders-list">
            <ion-item-divider></ion-item-divider>
            <ion-item
              *ngFor="let order of orders; let i = index"
              id="order-number-{{ i }}"
              [class.selected]="
                serviceRequestService.modalRelatedParams.order === order
              "
              detail="true"
              (click)="getProductsByOrder(order)"
              data-cy="click-get-products-and-order-number"
            >
              <ion-label>
                <p
                  class="info-top"
                  [attr.data-cy]="
                    'order-number-' +
                    order?.orderHeader?.tandemOrderNumber +
                    '-text'
                  "
                >
                  <!-- Order Number -->
                  {{ 'i18n.requestCredit.order' | translate }}&nbsp;
                  {{ order?.orderHeader?.tandemOrderNumber || '-' }}&nbsp;
                  <!-- Delivery Method -->
                  ({{ getOrderTypeLabel(order) | translate }})
                </p>
                <p class="order-info-bottom">
                  <!-- Order Placed -->
                  <span
                    [attr.data-cy]="
                      'order-placed-date-' +
                      order?.orderHeader?.tandemOrderNumber +
                      '-text'
                    "
                  >
                    {{ 'i18n.requestCredit.orderPlaced' | translate }}&nbsp;
                    {{ order?.orderHeader?.orderDate | date: 'M/d/yy':'GMT' }}
                  </span>
                  <span>|</span>
                  <!-- Delivered -->
                  <span
                    [attr.data-cy]="
                      'order-confirmed-delivery-date-' +
                      order?.orderHeader?.tandemOrderNumber +
                      '-text'
                    "
                  >
                    {{ 'i18n.requestCredit.delivered' | translate }}&nbsp;
                    {{
                      order?.orderHeader?.confirmedDeliveryDate
                        | date: 'M/d/yy':'GMT'
                    }}
                  </span>
                </p>
              </ion-label>
            </ion-item>
          </ion-list>
        </ion-col>

        <!-- Product Options -->
        <ng-container
          *ngIf="serviceRequestService?.products$ | async as products"
        >
          <ion-col
            *ngIf="serviceRequestService.modalRelatedParams.order"
            class="options"
            offset="0.5"
            size="5.75"
          >
            <div class="options-title">
              <ion-label id="products-searchbar" data-cy="select-product-label">
                {{ 'i18n.requestCredit.selectProduct' | translate }}
              </ion-label>
            </div>
            <div class="searchbar-section">
              <ion-searchbar
                aria-labelledby="products-searchbar"
                id="products-searchbar"
                data-cy="products-searchbar-input"
                placeholder="{{
                  'i18n.requestCredit.searchProductsFromOrder' | translate
                }}"
                class="search"
                mode="md"
                [(ngModel)]="serviceRequestService.searchKey"
                (ionInput)="filterProductNumbers()"
                [debounce]="serviceRequestService?.debounceTime"
              >
              </ion-searchbar>
            </div>
            <div
              *ngIf="!products?.length && serviceRequestService?.searchKey"
              class="no-data-found"
            >
              <p data-cy="no-product-numbers-found-text">
                {{ 'i18n.requestCredit.noProductNumbersFound' | translate }}
              </p>
            </div>
            <ion-list *ngIf="products?.length" class="products-list">
              <ion-item-divider></ion-item-divider>
              <ion-radio-group
                class="radio-options"
                value="{{
                  serviceRequestService.modalRelatedParams.productNumber
                }}"
              >
                <ion-item
                  *ngFor="let product of products"
                  (click)="onSelectProduct(product)"
                >
                  <ion-thumbnail *ngIf="product?.productImage" slot="start">
                    <img src="{{ product.productImage }}" />
                  </ion-thumbnail>
                  <ion-icon
                    *ngIf="!product?.productImage"
                    name="restaurant"
                    slot="start"
                  ></ion-icon>
                  <div class="radio-option-text">
                    <ion-label
                      [attr.data-cy]="
                        'product-number-' + product?.productNumber + '-text'
                      "
                    >
                      #{{ product?.productNumber }}
                      &nbsp;|&nbsp;
                      {{ product?.productPackSize }}
                    </ion-label>
                    <ion-label data-cy="product-description-text-link">
                      {{ product?.productDescription | titlecase }}
                    </ion-label>
                  </div>
                  <ion-radio
                    mode="md"
                    slot="end"
                    value="{{ product?.productNumber }}"
                    [attr.data-cy]="
                      'product-' + product?.productNumber + '-radio'
                    "
                  ></ion-radio>
                </ion-item>
              </ion-radio-group>
            </ion-list>
          </ion-col>
        </ng-container>
      </ion-row>
    </ion-grid>
  </ng-container>
</ion-content>

<ion-footer class="ion-footer-modal ion-footer-modal-desktop">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="cancel-modal-btn"
        data-cy="cancel-order-and-products-modal-button"
        class="usf-outline-green-dsktp-tblt-modal-button"
        (click)="dismissModal(true)"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        id="select-modal-btn"
        class="select-modal-btn"
        data-cy="select-order-and-products-modal"
        [ngClass]="
          !serviceRequestService.modalRelatedParams.product
            ? 'usf-fill-disabled-dsktp-tblt-modal-button'
            : 'usf-fill-green-dsktp-tblt-modal-button'
        "
        (click)="dismissModal(false)"
      >
        {{ 'i18n.requestCredit.select' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>

<!--Spinner Template-->
<ng-template #spinner>
  <div class="spinner-container">
    <ion-label id="loading-orders">
      {{ 'i18n.requestCredit.loadingOrders' | translate }}
    </ion-label>
    <ion-spinner
      aria-labelledby="loading-orders"
      name="circles"
      class="order-spinner"
      data-cy="loading-spinner"
    ></ion-spinner>
  </div>
</ng-template>
